var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreepik1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 154,
    viewBox: "0 0 192 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5716 42.2626C22.0414 36.2191 23.7505 30.337 26.5924 24.9826C34.21 10.6834 51.7492 -2.40617 68.6884 0.790626C84.1636 3.70903 95.9476 15.7234 112.023 17.7298C138.903 21.0898 147.543 1.40982 172.503 12.4498C182.674 16.9474 189.749 25.4722 190.906 36.6658C192.284 50.0338 184.594 59.4082 181.628 71.7298C178.205 85.9378 185.837 98.8834 188.088 112.53C189.384 120.407 188.42 128.691 184.08 135.522C178.176 144.824 166.733 148.751 157.143 153.066H23.7028C23.7028 153.066 15.5428 151.626 5.46278 131.466C-4.61722 111.306 3.54278 96.4258 16.0228 81.5458C22.4596 73.8658 22.9252 65.1298 21.8692 55.597C21.3353 51.1726 21.2356 46.7065 21.5716 42.2626Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.7,
    d: "M21.5716 42.2626C22.0414 36.2191 23.7505 30.337 26.5924 24.9826C34.21 10.6834 51.7492 -2.40617 68.6884 0.790626C84.1636 3.70903 95.9476 15.7234 112.023 17.7298C138.903 21.0898 147.543 1.40982 172.503 12.4498C182.674 16.9474 189.749 25.4722 190.906 36.6658C192.284 50.0338 184.594 59.4082 181.628 71.7298C178.205 85.9378 185.837 98.8834 188.088 112.53C189.384 120.407 188.42 128.691 184.08 135.522C178.176 144.824 166.733 148.751 157.143 153.066H23.7028C23.7028 153.066 15.5428 151.626 5.46278 131.466C-4.61722 111.306 3.54278 96.4258 16.0228 81.5458C22.4596 73.8658 22.9252 65.1298 21.8692 55.597C21.3353 51.1726 21.2356 46.7065 21.5716 42.2626Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreepik1);
export default __webpack_public_path__ + "static/media/freepik1.a54b6bc2ba3bfc419570a420816f7164.svg";
export { ForwardRef as ReactComponent };